import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/AppShell";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import PatientsPage from "@/pages/PatientsPage";
import PatientDetailPage from "@/pages/PatientDetailPage";
import CaseReviewPage from "@/pages/CaseReviewPage";
import ReportsPage from "@/pages/ReportsPage";
import AuditPage from "@/pages/AuditPage";
import UsersPage from "@/pages/UsersPage";
import OrganizationsPage from "@/pages/OrganizationsPage";
import MarketplacePage from "@/pages/MarketplacePage";
import BrandDetailPage from "@/pages/BrandDetailPage";

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-sm text-slate-500">Loading CareStop…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <AppShell>{children}</AppShell>;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
            <Route path="/" element={<Protected><DashboardPage /></Protected>} />
            <Route path="/patients" element={<Protected><PatientsPage /></Protected>} />
            <Route path="/patients/:id" element={<Protected><PatientDetailPage /></Protected>} />
            <Route path="/cases/:id" element={<Protected roles={["admin", "doctor", "staff", "patient", "nutritionist", "insurance"]}><CaseReviewPage /></Protected>} />
            <Route path="/reports" element={<Protected roles={["admin", "doctor", "staff", "patient", "nutritionist", "insurance"]}><ReportsPage /></Protected>} />
            <Route path="/audit" element={<Protected roles={["admin", "doctor"]}><AuditPage /></Protected>} />
            <Route path="/users" element={<Protected roles={["admin"]}><UsersPage /></Protected>} />
            <Route path="/organizations" element={<Protected roles={["admin"]}><OrganizationsPage /></Protected>} />
            <Route path="/marketplace" element={<Protected><MarketplacePage /></Protected>} />
            <Route path="/marketplace/:id" element={<Protected><BrandDetailPage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
